import { useQuery } from '@tanstack/react-query';
import shopService from '../services/salesShopItems.service';

export const usePaymentLink = (paymentLinkId?: string) => {
    const result = useQuery({
        queryKey: ['paymentLink'],
        queryFn: async () => {
            const response = await shopService.getPaymentLink(paymentLinkId!);
            return response;
        },
        enabled: !!paymentLinkId,
    });

    return result;
};
